export const region = [
    'EMEIA',
    'Americas',
    // 'APAC'
]
 
export const countries = [
 
    {
        region: 'Americas',
        country:'United States'
    },
    {
        region: 'EMEIA',
        country:'United Kingdom'
    }
    // ,
    // {
    //     region:'APAC',
    //     country:'Australia'
    // }
]

